import {
    Box,
    Button,
    Typography,
    Grid,
    Tooltip,
    Container,
} from '@mui/material';

import bgImage from '../../images/background.jpg';

const SectionLarge = () => {
    return (
        <Box component='section' py={{ xs: 0, sm: 12 }}>
            <Box
                variant='gradient'
                //bgColor='dark'
                position='relative'
                borderRadius={3}
                sx={{
                    overflow: 'hidden',
                    //la couleur du background dépend de la couleur de l'image de fond
                    background: '#183052',
                }}
            >
                <Box
                    component='img'
                    src={bgImage}
                    alt='pattern-lines'
                    position='absolute'
                    top={0}
                    left={0}
                    width='100%'
                    zIndex={1}
                    sx={{
                        opacity: 0.6,
                    }}
                />
                <Container sx={{ position: 'relative', zIndex: 2, py: 12 }}>
                    <Grid
                        container
                        item
                        xs={12}
                        md={7}
                        justifyContent='center'
                        mx='auto'
                        textAlign='center'
                    >
                        <Typography variant='h3' color='white'>
                            Non consectetur aliquip cillum
                        </Typography>
                        <Typography variant='h3' color='white' mb={1}>
                            Aliquip ipsum pariatur ullam ?
                        </Typography>
                        <Typography variant='body2' color='white' mb={6}>
                            Non duis pariatur eu ipsum incididunt elit nulla.
                            Duis elit occaecat ex ullamco excepteur nostrud
                            reprehenderit amet labore nisi excepteur culpa sit
                            cupidatat. Est duis consequat laborum eiusmod et
                            sunt dolor culpa.
                        </Typography>
                        <Button
                            variant='gradient'
                            color='info'
                            size='large'
                            component='a'
                            href='#'
                            target={'_blank'}
                            sx={{
                                mb: 2,
                                background: `linear-gradient(to right bottom, rgba(20, 116, 190, 0.8), rgba(126, 177, 200, 0.8))`,
                            }}
                        >
                            Lorem Ipsum
                        </Button>
                    </Grid>
                </Container>
            </Box>
            <Container>
                <Grid container item xs={5} mx='auto'>
                    <Box textAlign='center'>
                        <Typography variant='h3' mt={6} mb={3}>
                            Ut id velit exercitation
                        </Typography>
                        <Grid container spacing={3} justifyContent='center'>
                            <Grid item xs={4} lg={2}>
                                <Tooltip title='Dolor elit cupidatat voluptate velit commodo laborum laborum.'>
                                    <Box component='a' href='#' target='_blank'>
                                        <Box
                                            component='img'
                                            src='https://itcareerswitch.co.uk/wp-content/uploads/2022/10/bootstrap-square-logo.png'
                                            width='100%'
                                        />
                                    </Box>
                                </Tooltip>
                            </Grid>
                            <Grid item xs={4} lg={2}>
                                <Tooltip title='Veniam eu culpa deserunt labore proident consequat esse.'>
                                    <Box
                                        component='a'
                                        href='#'
                                        target='_blank'
                                        onClick={(e) => e.preventDefault()}
                                        sx={{ opacity: 0.5 }}
                                    >
                                        <Box
                                            component='img'
                                            src='https://sudoaugustin.gallerycdn.vsassets.io/extensions/sudoaugustin/tailwindcss-transpiler/0.0.8/1637868312894/Microsoft.VisualStudio.Services.Icons.Default'
                                            width='100%'
                                        />
                                    </Box>
                                </Tooltip>
                            </Grid>
                            <Grid item xs={4} lg={2}>
                                <Tooltip title='Velit minim aliqua est in elit.'>
                                    <Box
                                        component='a'
                                        href='#'
                                        target='_blank'
                                        onClick={(e) => e.preventDefault()}
                                        sx={{ opacity: 0.5 }}
                                    >
                                        <Box
                                            component='img'
                                            src='https://logospng.org/download/vue.js/vue-js-256.png'
                                            width='100%'
                                        />
                                    </Box>
                                </Tooltip>
                            </Grid>
                            <Grid item xs={4} lg={2}>
                                <Tooltip title='Reprehenderit occaecat ex occaecat reprehenderit.'>
                                    <Box
                                        component='a'
                                        href='#'
                                        target='_blank'
                                        onClick={(e) => e.preventDefault()}
                                        sx={{ opacity: 0.5 }}
                                    >
                                        <Box
                                            component='img'
                                            src='https://cdn.iconscout.com/icon/free/png-256/angular-226066.png'
                                            width='100%'
                                        />
                                    </Box>
                                </Tooltip>
                            </Grid>
                            <Grid item xs={4} lg={2}>
                                <Tooltip title='Cupidatat tempor voluptates minim proident.'>
                                    <Box
                                        component='a'
                                        href='#'
                                        target='_blank'
                                        onClick={(e) => e.preventDefault()}
                                        sx={{ opacity: 0.5 }}
                                    >
                                        <Box
                                            component='img'
                                            src='https://cdn.iconscout.com/icon/free/png-256/logo-1889531-1597591.png'
                                            width='100%'
                                        />
                                    </Box>
                                </Tooltip>
                            </Grid>
                            <Grid item xs={4} lg={2}>
                                <Tooltip title='Consectetur consequat id officia consequat officia.'>
                                    <Box
                                        component='a'
                                        href='#'
                                        target='_blank'
                                        onClick={(e) => e.preventDefault()}
                                        sx={{ opacity: 0.5 }}
                                    >
                                        <Box
                                            component='img'
                                            src='https://cdn.iconscout.com/icon/free/png-256/sketch-61-722739.png'
                                            width='100%'
                                        />
                                    </Box>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Container>
        </Box>
    );
};

export default SectionLarge;
